import ApplicationController from "./application_controller"

export default class extends ApplicationController {
  static targets = ["checkbox"]

  toggleForDestruction(event) {
    this.checkboxTarget.value = !event.target.checked
  }
}
